import { LocalConfig } from '../../common/constants/localConfig';
import { AppState } from '../../app-state';
import { StartPage } from '../../areas/startPage/startPage';
import ErrorModal from '../../common/components/modal/ErrorModal.component';
import { ErrorState } from '../../common/reducers/errorMessage';
import * as React from 'react';
import { Provider } from 'react-redux';
import { HashRouter, Redirect, Route, Switch } from 'react-router-dom';
import { AnalyticsRoute } from '@chr/online-shared-ui-analytics';
import { Store } from 'redux';
import { LinkService, isAuthed } from '@chr/online-shared-microsite-core';
import { ConfigContext } from '@chr/navisphereonline-shared-components';
import ReCaptcha from '../../common/components/recaptcha/Recaptcha.component';
import PayInvoice from '../payInvoice/payInvoice';
import './app.component.scss';

interface AppComponentProps {
  store: Store<AppState>;
  config: LocalConfig;
}

interface AppComponentState {
  error: Error;
  errorInfo: React.ErrorInfo;
  errorState: ErrorState;
}

export const App = ({store, config} : AppComponentProps) => {
  const redirectToPageNotFound = () => {
    if (isAuthed()) {
      LinkService.getLinks().then(() => {
        window.location.assign(LinkService.PAGE_NOT_FOUND);
      });
    } else {
      return <Redirect to="/" />;
    }
    return null;
  }

  return (
    <Provider store={store}>
      <div className="container">
        <ConfigContext.Provider value={config}>
          <ReCaptcha config={config}/>
          <HashRouter>
            <Switch>
              <AnalyticsRoute path="/" strict exact render={() => <StartPage config={config} />} pageName={'SecurePay | Select Invoices'} />
              <AnalyticsRoute path="/pay-invoices" render={() => <PayInvoice config={config} />} pageName={'Pay Invoices'} />
              <Route path={["/summary", "/payment-method", "/review", "/confirmation"]} render={() => <Redirect to='/pay-invoices' />} />
              <AnalyticsRoute component={redirectToPageNotFound} pageName={'Customer Apps | Page Not Found'} />
            </Switch>
          </HashRouter>
          <ErrorModal />
        </ConfigContext.Provider>
      </div>
    </Provider>
  );
};
